const initialState = {
    socket: {
        isConnected: false,
        message: '',
        reconnectError: false,
    },
};
export const socket = {
    namespaced: true,
    state: initialState,
    getters: {
        socket: state => {
            return state.socket;
        },
    },
    actions: {},
    mutations: {
        SOCKET_ONMESSAGE(state, message) {
            state.socket.message = message;
        },
        SOCKET_ONOPEN(state, data) {
            state.socket.isConnected = true;
        },
        SOCKET_ONCLOSE(state, data) {
            state.socket.isConnected = false;
        },
        SOCKET_RECONNECT_ERROR(state) {
            state.socket.reconnectError = true;
        },
        SOCKET_ONERROR(state, event) {
            // console.error(state, event)
        },
        SOCKET_RECONNECT(state, count) {
            // console.info(state, count)
        },
    },
};
